import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_DE.json';
import audios from './LOVE_AUDIOS_DE.json';

export const LOVE_DATA_DE: ServiceData = {
  articles,
  audios,
};
